var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.997 8.029l.623-1.63c.104-.274-.097-.566-.39-.566H8.705c.286-.492.463-1.057.463-1.666v-.008c1.021-.203 1.667-.498 1.667-.826 0-.346-.711-.653-1.826-.859C8.77 1.62 8.307.76 7.953.318 7.706.008 7.28-.09 6.924.088l-.718.36c-.235.117-.51.117-.745 0l-.719-.36c-.354-.177-.781-.08-1.028.23-.352.442-.818 1.302-1.058 2.156-1.112.206-1.823.513-1.823.86 0 .327.646.622 1.667.825v.008c0 .609.177 1.174.464 1.666H1.466c-.3 0-.5.305-.383.581l.672 1.568C.711 8.589 0 9.706 0 11v1.167c0 .643.523 1.166 1.167 1.166H10.5c.643 0 1.167-.523 1.167-1.166V11c0-1.26-.672-2.354-1.67-2.971zM4.583 12.5L3.5 7.5l1.292.833.625 1.042-.834 3.125zm2.5 0L6.25 9.375l.625-1.042L8.167 7.5l-1.084 5zM8.17 4.727c-.101.31-.182.64-.43.87-.262.242-1.25.583-1.666-.652-.073-.218-.401-.218-.477 0-.442 1.308-1.458.844-1.666.651-.248-.229-.331-.56-.43-.87-.02-.065-.164-.148-.164-.15v-.282c.737.094 1.588.151 2.5.151.911 0 1.763-.054 2.5-.15v.28c-.003.003-.146.084-.167.152z",
    transform: "translate(-59 -478) translate(16 262) translate(0 140) translate(43 76) translate(2 1.333)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpy);
export default __webpack_public_path__ + "static/media/spy.b9166a81d677fd20b150763bb6bc77fc.svg";
export { ForwardRef as ReactComponent };